"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* istanbul ignore file */
var IProcessor = /*#__PURE__*/function () {
  function IProcessor() {
    (0, _classCallCheck2["default"])(this, IProcessor);
  }
  return (0, _createClass2["default"])(IProcessor, [{
    key: "processPayload",
    value: function processPayload() {}
  }]);
}();
module.exports = IProcessor;